import { SELECT_SIZE, UPDATE_STATS, UPDATE_STEPS, SET_SWAP_DURATION } from './actions';
import { SET_BLOCK, SET_CELLS, SET_OVER } from './actions';
import { SET_STEPS, SET_INIT } from './actions';
import * as f from '../logic';
import _ from 'lodash';
import { SET_RESTART } from '../../HOME/REDUX/actions';
import { dbdel } from '../../HOME/utils';
import { HELPED_KEY } from '../const';

export default (state = {}, action) => {
  switch (action.type) {
    case SELECT_SIZE:
      return { ...state, size: action.size };
    case UPDATE_STATS:
      return onUpdateStats(state, action.stats);
    case UPDATE_STEPS:
      const { update } = action;
      return { ...state, steps: update === undefined ? (state.steps || 0) + 1 : update };
    case SET_BLOCK:
      return { ...state, blocked: action.blocked };
    case SET_INIT:
      return { ...state, init: action.init };
    case SET_OVER:
      return { ...state, over: action.over };
    case SET_CELLS:
      return { ...state, cells: action.cells };
    case SET_RESTART:
      return { ...state, restart: action.restart, over: false };
    case SET_STEPS:
      return { ...state, steps: action.steps };
    case SET_SWAP_DURATION:
      return { ...state, swapDuration: action.swapDuration };
    case HELPED_KEY:
      return { ...state, helped: true };
    default:
      return state;
  }
};

function onUpdateStats(state, stats) {
  if (!stats) {
    dbdel(f.statsKey(state));
    stats = { plays: 0, aggScore: 0, aveScore: 0, bestScore: 0 };
  } else {
    let { plays, aggScore, bestScore } = stats;

    const aveScore = plays === 0 ? 0 : _.round((aggScore || 0) / plays);

    stats = { plays, aggScore, aveScore, bestScore };
  }

  return { ...state, stats };
}
